import PassengersScreen from './PassengersScreen';

export default PassengersScreen;
